var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLogin)?[_c('MainPageView')]:(!_vm.isLogin && _vm.isReady)?[_c('LoginView')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }